<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('mobileLogsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="mobile-log-workspace">
      <app-master-table
        [title]="'mobileLogsCatalog.title' | translate"
        [dataSource]="dataSource"
        [columnDefinitions]="columnDefinitions"
        [actions]="actions"
        [filters]="tableFilters"
        [isLoading]="isLoading"
        [enableRowClick]="true"
        [disableRowClickToEdit]="true"
        [rowClickSelection]="false"
        [showContextMenu]="false"
        [useServerData]="true"
        [totalItems]="totalItems"
        [currentPage]="currentPage"
        [pageSize]="pageSize"
        [pageSizeOptions]="[15, 25, 50, 100, 200]"
        [tableMaxHeight]="'100%'"
        [searchValue]="searchValue"
        [exportFileName]="'mobile-logs'"
        (rowClick)="handleView($event)"
        (details)="handleView($event)"
        (refresh)="loadData()"
        (searchChange)="onSearchChange($event)"
        (filtersChange)="onFiltersChange($event)"
        (filterSearchChange)="onFilterSearchChange($event)"
        (pageChange)="onPageChange($event)">
      </app-master-table>
    </div>
  </div>
</section>
